import * as React from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { IconButton } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { DownloadData, generateExcel } from '../../utils/excel-file';
// import {ReactComponent as ExcelIcon} from '../../assets/images/mi-portal/excel-icon.svg';
// import {ReactComponent as PDFIcon} from '../../assets/images/pdf-icon.svg';

interface DownloadOptionsProps {
    downloadData?: DownloadData
}

const DownloadOptions = ({downloadData}: DownloadOptionsProps) =>  {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!downloadData) {
    return <></>
  }

  return (
    <div>
        <IconButton
            id="demo-positioned-button"
            aria-controls={open ? 'demo-positioned-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            color='primary'
            style={{padding: 0, }}
        >
            <FileDownloadIcon />
        </IconButton>
        <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
        >
            <MenuItem 
                onClick={() => {
                    const doc = new jsPDF({orientation: "landscape"})
                    autoTable(doc, { html: '#my-table' })
                    const filteredBodyRows: string[][] = []
                    const filteredHeadRows: any = downloadData.tableHeadRows.filter(r => r.label !== "");
                    const rowsHeadArray: any[] = [filteredHeadRows.map((head: any, ii: number) => head.label)];
                    downloadData.tableBodyRows.forEach((row: any, i: number) => (
                        filteredBodyRows.push(filteredHeadRows.map((hKey: any, ii: number) => row[ii].value))
                    ));
                    autoTable(doc, {
                        head: rowsHeadArray,
                        body: filteredBodyRows,
                        headStyles: {fillColor: "#63AFC8"}
                    })
                    doc.save('documento-usuario.pdf')
                    handleClose();
                }}
            >
                descargar PDF
            </MenuItem>
            <MenuItem 
                onClick={async () =>{ 
                    generateExcel(downloadData)
                    handleClose();
                }}
            >
                descargar CSV
            </MenuItem>
            {/* <Grid item>
                <Button 
                    variant="contained"
                    disableElevation
                    style={{
                        border: theme.s10palette.S10Greygrey50,
                        backgroundColor: "#EFF4F6",
                        color: theme.s10palette.S10Greygrey600,
                        marginRight: ".5rem",
                        minWidth: "2rem",
                        width: "2.5rem",
                        height: "2.5rem",
                        padding: "0",
                    }}
                    onClick={() => generateExcel(downloadData)}
                >
                    <ExcelIcon  height="1.8rem" width="1.8rem"/>    
                </Button>
                <Button 
                    variant="contained"
                    disableElevation
                    style={{
                        border: theme.s10palette.S10Greygrey50,
                        backgroundColor: "#EFF4F6",
                        color: theme.s10palette.S10Greygrey600,
                        marginRight: ".5rem",
                        minWidth: "2rem",
                        // width: "2.5rem",
                        height: "2.5rem",
                        padding: "0",
                    }}
                    onClick={() => {
                        const doc = new jsPDF({orientation: "landscape"})
                        autoTable(doc, { html: '#my-table' })
                        const filteredBodyRows: string[][] = []
                        const filteredHeadRows: any = downloadData.tableHeadRows.filter(r => r.label !== "");
                        const rowsHeadArray: any[] = [filteredHeadRows.map((head: any, ii: number) => head.label)];
                        downloadData.tableBodyRows.forEach((row: any, i: number) => (
                            filteredBodyRows.push(filteredHeadRows.map((hKey: any, ii: number) => row[ii].value))
                        ));
                        autoTable(doc, {
                          head: rowsHeadArray,
                          body: filteredBodyRows,
                          headStyles: {fillColor: "#63AFC8"}
                        })
                        doc.save('documento-usuario.pdf')
                    }}
                >
                    <PDFIcon height="1.8rem" width="1.8rem"/>
                </Button>
            </Grid> */}
        </Menu>
    </div>
  );
}

export default DownloadOptions;